import { message } from "antd";
import { call, put, takeEvery } from "redux-saga/effects";
import { actionTypes as profileActionTypes } from "../profile/reducer";
import { whoami } from "../profile/service";
import { actionTypes as authActionTypes } from "./reducer";
import {
  changePassword as changePasswordService,
  customerLogin as customerLoginService,
  forgotPassword as forgotPasswordService,
  logout as logoutService,
  login as loginService,
  resetPassword as resetPasswordService
} from "./service";

function* logout(action) {
  const { payload } = action;
  yield call(logoutService, payload);
}

function* login(action) {
  const { payload } = action;
  try {
    const auth = yield call(loginService, payload);

    if (auth === "Inactive") {
      message.error(
        "Your contract has ended. Please contact your Sales Director."
      );
      yield put({ type: authActionTypes.LOGIN_FAILED });
      return;
    }

    yield put({ type: authActionTypes.LOGIN_SUCCESS, auth });

    const profile = yield call(whoami);
    yield put({
      type: profileActionTypes.GET_PROFILE_REQUEST_SUCCESS,
      profile
    });
  } catch (errors) {
    message.error("Invalid Username/Password");
    yield put({ type: authActionTypes.LOGIN_FAILED, errors });
  }
}

function* customerLogin(action) {
  const { payload } = action;

  try {
    const auth = yield call(customerLoginService, payload);
    yield put({ type: authActionTypes.CUSTOMER_LOGIN_REQUEST_SUCCESS, auth });

    const profile = yield call(whoami);
    yield put({
      type: profileActionTypes.GET_PROFILE_REQUEST_SUCCESS,
      profile
    });
  } catch (errors) {
    message.error(errors);
    yield put({ type: authActionTypes.CUSTOMER_LOGIN_REQUEST_FAILED, errors });
  }
}

function* changePassword(action) {
  const { payload } = action;

  const changePassword = yield call(changePasswordService, payload);
  yield put({ type: authActionTypes.CHANGE_PASSWORD_SUCCESS, changePassword });
}

function* forgotPassword(action) {
  const { payload } = action;
  const { response, error } = yield call(forgotPasswordService, payload);
  console.log("response: ", response, "error: ", error);
  if (response)
    yield put({ type: authActionTypes.FORGOT_PASSWORD_SUCCESS, response });
  else message.error(error);
  yield put({ type: authActionTypes.FORGOT_PASSWORD_FAILED, error });
}

function* resetPassword(action) {
  const { payload } = action;
  const { response, error } = yield call(resetPasswordService, payload);
  if (response) {
    console.log("response: ", response);
    yield put({ type: authActionTypes.RESET_PASSWORD_SUCCESS, response });
  } else {
    console.log("error: ", error);
    yield put({ type: authActionTypes.RESET_PASSWORD_FAILED, error });
  }
}

function* watchLoginRequest() {
  yield takeEvery(authActionTypes.LOGOUT_REQUEST, logout);
  yield takeEvery(authActionTypes.LOGIN_REQUEST, login);
  yield takeEvery(authActionTypes.CUSTOMER_LOGIN_REQUEST, customerLogin);
  yield takeEvery(authActionTypes.CHANGE_PASSWORD_REQUEST, changePassword);
  yield takeEvery(authActionTypes.FORGOT_PASSWORD_REQUEST, forgotPassword);
  yield takeEvery(authActionTypes.RESET_PASSWORD_REQUEST, resetPassword);
}

export default [watchLoginRequest()];
